import { ReactNode } from 'react'

interface AccordionProps {
  title: string
  icon?: ReactNode
  children: ReactNode
  defaultOpen?: boolean
  open?: boolean
  onToggle?: () => void
  className?: string
}

export function Accordion({
  title,
  icon,
  children,
  defaultOpen = false,
  open,
  onToggle,
  className = ''
}: AccordionProps) {
  const isControlled = open !== undefined && onToggle !== undefined
  
  return (
    <div className={`collapse collapse-arrow bg-base-100 shadow-xl ${className}`}>
      <input
        type="checkbox"
        checked={isControlled ? open : undefined}
        defaultChecked={!isControlled ? defaultOpen : undefined}
        onChange={isControlled ? onToggle : undefined}
      />
      <div className="collapse-title text-xl font-medium flex items-center gap-2">
        {icon}
        {title}
      </div>
      <div className="collapse-content">
        {children}
      </div>
    </div>
  )
}
